import styled from "styled-components";
import { Image as AntImage } from "antd";

export const NotiContainer = styled.div`
  height: 100vh;
  position: relative;

  .infinite-scroll-component__outerdiv {
    height: calc(100vh - 85px);
  }

  .infinite-scroll-component {
    height: 100% !important;
    overflow-x: hidden !important;
  }
`;

export const NotiCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NotiDate = styled.div`
  font-size: 12px;
  margin-top: 16px;
`;

export const NotiCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-top: 14px;
  background-color: #fff;
  border-radius: 18px;
  width: 90%;
  white-space: pre-wrap;
`;

export const NotiTitle = styled.p`
  color: #000;
  font-size: 15px;
  margin-top: 10px;
`;

export const NotiDes = styled.p`
  color: #6b6b6b;
  font-size: 14px;
  font-family: Myanmar Phetsot;
  margin-top: 0px;
  padding-top: 0px;
`;

export const NotiTime = styled.span`
  color: #888888;
  font-size: 10px;
  text-align: right;
`;

export const Mute = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(109, 29, 122, 1) 0%,
    rgba(148, 55, 140, 1) 100%
  );
  height: 62px;
  position: sticky;
  bottom: 0;
  width: 100%;
  margin-top: 16px;
`;

export const MuteTitle = styled.p`
  color: #fff;
  font-size: 18px;
`;

export const SpinWrapper = styled.div`
  padding-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 75px);
`;

export const EmptyText = styled.div`
  padding-top: 24px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Image = styled(AntImage).attrs({
  preview: false,
})`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1 / 0.5;
  border-radius: 5px;
  margin-bottom: 6px;
`;
